<app-navbar-style-two></app-navbar-style-two>

<div class="hero-inner">
  <h2 class="hero-title">Contact Us</h2>
</div>

<section class="contact-area pt-100 pb-100">
  <div class="container">
    <div class="contact-wrapper">
      <div class="row g-0 align-items-stretch">

        <div class="col-lg-7">
          <div class="contact-form-card">
            <h2>Send Us A Message</h2>
            <p class="sub-text">
              We'd love to hear from you. Fill out the form below and our team will get back to you shortly.
            </p>

            <form [formGroup]="contactForm">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Name <span class="text-danger">*</span></label>
                    <input formControlName="lead_name" class="form-control" placeholder="Enter your name">
                    <div *ngIf="contactForm.get('lead_name')?.invalid && contactForm.get('lead_name')?.touched" class="text-danger small mt-1">Name is required.</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Phone <span class="text-danger">*</span></label>
                    <input formControlName="contact_phone" class="form-control" type="tel" placeholder="Enter phone number" (input)="restrictToNumbers($event)" (keydown)="preventNonNumeric($event)">
                    <div *ngIf="contactForm.get('contact_phone')?.invalid && (contactForm.get('contact_phone')?.dirty || contactForm.get('contact_phone')?.touched)" class="text-danger small mt-1">
                      <span *ngIf="contactForm.get('contact_phone')?.errors?.['required']">Phone is required.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Email</label>
                    <input formControlName="contact_email" class="form-control" type="email" placeholder="Enter email">
                    <div *ngIf="contactForm.get('contact_email')?.invalid && contactForm.get('contact_email')?.touched" class="text-danger small mt-1">Please enter a valid email.</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Location <span class="text-danger">*</span></label>
                    <input formControlName="delivery_location" class="form-control" placeholder="Enter your location">
                    <div *ngIf="contactForm.get('delivery_location')?.invalid && contactForm.get('delivery_location')?.touched" class="text-danger small mt-1">Location is required.</div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group mb-3">
                    <label>Description</label>
                    <textarea formControlName="scope_of_project" class="form-control" rows="5" placeholder="Enter your message"></textarea>
                  </div>
                </div>
              </div>
            </form>

            <button type="button" class="enquire-btn" (click)="submitContactForm()" [disabled]="isLoading">
              <i class='bx' [ngClass]="isLoading ? 'bx-loader-alt bx-spin' : 'bxs-paper-plane'"></i>
              {{ isLoading ? 'Loading...' : 'Enquire Now' }}
            </button>
          </div>
        </div>

        <div class="col-lg-5">
          <div class="contact-side-panel">
            <div class="contact-info-box">
              <div class="icon"><i class='bx bx-map'></i></div>
              <h3>Our Address</h3>
              <p>15171, Los Gatos Blvd<br>Los Gatos, CA 95032, USA</p>
            </div>
            <div class="contact-info-box">
              <div class="icon"><i class='bx bx-phone-call'></i></div>
              <h3>Contact</h3>
              <p>Mobile: ‎+1 (669) 871-0461</p>
             <p>E-mail: kitchenmagic013&#64;gmail.com</p>
             </div>
          </div>
        </div>
y
      </div>
    </div>
  </div>
</section>
<div class="map-wrapper container pb-100"> 
<div class="map-wrapper" style="text-align: center; width: 100%; margin-top: 10px;">
  <iframe 
    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d793.9918486487945!2d-121.9571537304525!3d37.248481065801556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDE0JzU0LjUiTiAxMjHCsDU3JzIzLjQiVw!5e0!3m2!1sen!2sin!4v1780315052085!5m2!1sen!2sin" 
    width="90%" 
    height="400" 
    style="border:0; border-radius:15px; display: inline-block;" 
    allowfullscreen="" 
    loading="lazy">
  </iframe>
</div>
</div>